import { apiClient, ApiResponse } from './client'

export type ComposeMode = 'WRONG' | 'ALL' | 'CUSTOM'
export type ScopeType = 'LESSON' | 'DAY'
export type ItemSource = 'SEEDED' | 'ADDED'
export type QuizSetStatus = 'DRAFT' | 'PRINTED'

export interface QuizSetItemView {
  itemId: number
  quizId: string // BigInt-safe: 항상 string
  source: ItemSource
  sortOrder: number
}

export interface QuizSetView {
  id: number
  composeMode: ComposeMode
  scopeType: ScopeType
  lessonContentId: number | null
  targetDate: string
  status: QuizSetStatus
  items: QuizSetItemView[]
}

export interface QuizPoolItemView {
  quizId: string
  title: string | null
  alreadyInSet: boolean
}

export interface ComposeQuizSetRequest {
  composeMode?: ComposeMode
  scopeType: ScopeType
  lessonContentId?: number | null
  date?: string
}

export const lcQuizSetApi = {
  // Legacy print set creation is an explicit user action. Print-page mounts must only read by setId.
  compose: async (learnerId: number, req: ComposeQuizSetRequest): Promise<QuizSetView> => {
    const res = await apiClient.post<ApiResponse<QuizSetView>>(
      `/lc/admin/coaching/learners/${learnerId}/quiz-sets`,
      req,
    )
    return res.data.data
  },
  getSet: async (learnerId: number, setId: number): Promise<QuizSetView> => {
    const res = await apiClient.get<ApiResponse<QuizSetView>>(
      `/lc/admin/coaching/learners/${learnerId}/quiz-sets/${setId}`,
    )
    return res.data.data
  },
  updateItems: async (
    learnerId: number,
    setId: number,
    body: { addQuizIds?: string[]; removeItemIds?: number[] },
  ): Promise<QuizSetView> => {
    const res = await apiClient.put<ApiResponse<QuizSetView>>(
      `/lc/admin/coaching/learners/${learnerId}/quiz-sets/${setId}/items`,
      body,
    )
    return res.data.data
  },
  getPool: async (learnerId: number, setId: number): Promise<QuizPoolItemView[]> => {
    const res = await apiClient.get<ApiResponse<QuizPoolItemView[]>>(
      `/lc/admin/coaching/learners/${learnerId}/quiz-sets/${setId}/pool`,
    )
    return res.data.data
  },
  // Requires an existing LEGACY_PRINT set; this endpoint never composes one.
  getPrintQuizIds: async (learnerId: number, setId: number): Promise<string[]> => {
    const res = await apiClient.get<ApiResponse<{ quizIds: string[] }>>(
      `/lc/admin/coaching/learners/${learnerId}/quiz-sets/${setId}/print-quizzes`,
    )
    return res.data.data.quizIds
  },
}
